import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/stores/create',
    name: 'storeCreate',
    component: () => import('@/views/restricted/distributor-networks/store/StoreCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_STORE_CREATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/stores/:storeId/edit',
    name: 'storeUpdate',
    component: () => import('@/views/restricted/distributor-networks/store/StoreUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_STORE_UPDATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/stores/:storeId',
    name: 'storeDetail',
    component: () =>
      import('@/views/restricted/distributor-networks/store/StoreDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_STORE_READ_PERMISSION'],
      menuSelected: 'networks'
    }
  }
]
